module.exports = __webpack_public_path__ + "static/media/4.2e93109b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/slides/4.jpg
// module id = 781
// module chunks = 0